module.exports = __webpack_public_path__ + "img/hamburger-opened.dec9e406.svg";